module.exports = __webpack_public_path__ + "img/sweden-colorectal-cancer-female.a6d0fc93.png";